(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      // Schwelle in FLASCHEN (nicht Cent).
      this.threshold = parseInt(this.dataset.threshold || '0', 10);
      this.textTpl = this.dataset.text || '';
      this.reachedText = this.dataset.reached || '';
      this._onUpdate = this.refresh.bind(this);
      document.addEventListener('cart:update', this._onUpdate);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:update', this._onUpdate);
    }
    async refresh() {
      if (!this.threshold) return;
      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        var cart = await res.json();
        // total_weight kommt in Gramm; 1 kg == 1 Flasche.
        this.render(Math.floor((cart.total_weight || 0) / 1000));
      } catch (e) {}
    }
    render(bottles) {
      var remaining = Math.max(0, this.threshold - bottles);
      var reached = remaining <= 0;
      var pct = Math.min(100, Math.round((bottles * 100) / this.threshold));
      var fill = this.querySelector('.free-shipping__fill');
      var text = this.querySelector('.free-shipping__text');
      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (reached) {
          this.classList.add('free-shipping--reached');
          text.innerHTML = '<span class="free-shipping__icon" aria-hidden="true">✓</span> ' + this.reachedText;
        } else {
          this.classList.remove('free-shipping--reached');
          var label = this.formatBottles(remaining);
          text.textContent = this.textTpl.replace('[flaschen]', label).replace('[betrag]', label);
        }
      }
    }
    formatBottles(n) {
      return n === 1 ? '1 Flasche' : n + ' Flaschen';
    }
  }
  if (!customElements.get('free-shipping-bar')) customElements.define('free-shipping-bar', FreeShippingBar);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nua-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.documentElement.classList.add('nua-reveal-ready');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    function collectItems(scope) {
      var items = [];
      (scope || document).querySelectorAll('[data-nua-reveal]').forEach(function (el) { items.push(el); });
      (scope || document).querySelectorAll('[data-nua-reveal-group]').forEach(function (group) {
        var step = parseInt(group.getAttribute('data-nua-reveal-step') || '70', 10);
        Array.prototype.forEach.call(group.children, function (el, i) {
          if (!el.style.getPropertyValue('--nua-reveal-delay')) {
            el.style.setProperty('--nua-reveal-delay', (i * step) + 'ms');
          }
          items.push(el);
        });
      });
      return items;
    }

    function observeAll(scope) {
      collectItems(scope).forEach(function (el) {
        if (!el.classList.contains('is-revealed')) io.observe(el);
      });
    }

    function init() { observeAll(document); }

    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }

    // Theme-Editor: neu eingefügte Sektionen ebenfalls erfassen.
    document.addEventListener('shopify:section:load', function (e) { observeAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nutrition-popup-drawer"] && !Shopify.designMode) return;
  try {
    class NutritionPopupLite extends HTMLElement {
    #wired = false;
    #controller = null;

    connectedCallback() {
      this.trigger = this.querySelector('.nutrition-popup__button');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog || this.#wired) return;
      this.#wired = true;

      // Alle Listener über einen AbortController registrieren, damit sie im
      // disconnectedCallback sauber in einem Rutsch abgebaut werden können.
      this.#controller = new AbortController();
      const signal = this.#controller.signal;

      // Der Cart-Drawer ist per transform verschoben → ein <dialog> darin
      // zentriert sich an diesem Container statt am Viewport (linksbündig).
      // Deshalb das Dialog ans <body> umhängen, damit showModal() korrekt
      // mittig im Viewport liegt.
      document.body.appendChild(this.dialog);

      this.closeBtn = this.dialog.querySelector('[data-close]');
      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Dialog ggf. (wieder) ans <body> hängen – nach einem Re-Render kann es
        // abgekoppelt sein, dann würfe showModal() einen Fehler (mobil beobachtet:
        // Button reagiert, aber kein Popup).
        if (this.dialog.parentElement !== document.body) document.body.appendChild(this.dialog);
        this.dialog.showModal();
        // Fokus explizit in den Dialog legen (Schließen-Button bevorzugt),
        // damit Tastatur-/Screenreader-Nutzer direkt im Modal landen.
        (this.closeBtn || this.dialog).focus();
      }, { signal });
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      }, { signal });
      // Fokus beim Schließen zurück auf das auslösende Trigger-Element. Da der
      // Dialog ans <body> umgehängt ist, geht der Fokus sonst verloren.
      this.dialog.addEventListener('close', () => {
        if (this.trigger && this.trigger.isConnected) this.trigger.focus();
      }, { signal });
    }

    disconnectedCallback() {
      // Registrierte Listener abbauen.
      if (this.#controller) {
        this.#controller.abort();
        this.#controller = null;
      }
      this.#wired = false;
      // ZUERST schließen (kein verwaister Top-Layer-Dialog), DANN das ans <body>
      // ausgelagerte Dialog ZURÜCK in die Komponente holen – NICHT entfernen.
      // Sonst findet ein erneutes connectedCallback (Karten-Re-Render, v. a. mobil)
      // das Dialog nicht mehr (this.querySelector('dialog') == null) und der
      // Trigger läuft ins Leere (Button nur :hover, kein Popup). Wird die
      // Komponente wirklich entfernt, wandert das Kind-Dialog ohnehin mit raus.
      if (this.dialog && this.dialog.parentElement === document.body) {
        this.dialog.close();
        this.appendChild(this.dialog);
      }
    }
  }
  if (!customElements.get('nutrition-popup-lite')) customElements.define('nutrition-popup-lite', NutritionPopupLite);
  } catch(e) { console.error(e); }
})();

})();
